import React from "react";
import { Link } from "react-router-dom";
import PrimaryButton from "../../components/PrimaryButton";
import useTitle from "../../Hooks/useTitle";

const ErrorPage = () => {
  useTitle("ErrorPage");
  return (
    <section className="flex items-center h-full p-16 dark:text-gray-100">
      <div className="container flex flex-col items-center justify-center px-5 mx-auto my-8">
        <div className="max-w-md text-center">
          <h2 className="mb-8 font-extrabold text-9xl dark:text-gray-600">
            404
          </h2>
          <p className="text-2xl my-5 font-semibold text-black md:text-3xl">
            Sorry, we couldn't find this page.
          </p>

          <Link to="/home">
            <PrimaryButton>Back to homepage</PrimaryButton>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ErrorPage;
